import { gql } from '@apollo/client'

export const PARTNER_SCREEN = gql`
  query MainBalanceByUser($input: mainBalanceByUserInput) {
    mainBalanceByUser(input: $input) {
      id
      mainBalance
      expirationDateMainBalance
      image
      logo
      commercialName
      partnerId
      shortDescription
      moreInfo
      requiresOKYBPurchaseReference
      user {
        id
        phoneNumber
        email
        firstName
        lastName
        subscribed
        verifyCode
      }
      pantone {
        id
        aliasId
        mainColor
        fontColor
        mainIconColor
        secondaryIconColor
        okyLogo
        showName
      }
    }
  }
`

export const PARTNER_SCREEN_BY_PARTNER = gql`
  query PartnerScreenByPartner($partnerId: Int) {
    mainBalanceByUserAndPartner(partnerId: $partnerId) {
      id
      mainBalance
      expirationDateMainBalance
      image
      partnerName
      partnerId
      requiresOKYBPurchaseReference
      user {
        id
        phoneNumber
        email
        firstName
        lastName
        subscribed
        verifyCode
      }
    }
  }
`

export const GET_SELECT_WALLET = gql`
  query SelectedWallet {
    selectedWallet @client
  }
`

export const RECENTLY_CREDITED_BALANCE = gql`
  query RecentlyCreditedBalance {
    recentlyCreditedBalance {
      amount
      partnerName
      date
    }
  }
`

export const VOUCHERS_PENDING_REDEMPTION = gql`
  query VouchersPendingRedemption {
    vouchersPendingRedemption {
      expirationDate
      partnerImage
      partnerName
      id
      partnerId
      aliasId
      phoneNumberRecipient
      phoneNumberSender
      senderName
      transactionId
      voucherCode
      voucherImage
      validacionCodigo
      voucherName
      fechaCompra
      expirationDateDDMMYYYYHHmm
      showQr
      Local_Amount
      Fulfilment_Flag
      Vocher_Type
      voucher_title
      voucher_sub_title
      description
      squareLogo
      iconCategory
    }
  }
`

export const VOUCHERS_PENDING_WITH_PANTONE = gql`
  query VouchersPendingWithPantone($countryId: ID!) {
    vouchersPendingWithPantone(countryId: $countryId) {
      id
      transactionId
      partnerId
      countryId
      aliasId
      partnerName
      validacionCodigo
      voucherName
      expirationDate
      expirationDateDDMMYYYYHHmm
      showQr
      fechaCompra
      partnerImage
      voucherImage
      senderName
      voucherCode
      phoneNumberSender
      phoneNumberRecipient
      fulfilmentFlag
      localAmount
      voucherType
      voucherTitle
      voucherSubTitle
      voucherId
      squareLogo
      description
      iconCategory
      idCategory
      integratorCode
      pantone {
        fontColor
        mainColor
        mainIconColor
        secondaryIconColor
        okyLogo
        showName
        logoOhGiftCard
      }
      steps {
        text
        idDetPasosCanje
        img
        fechaI
      }
    }
  }
`
